import React, { Component } from "react";
import Header from "../layout/Header";
import BriefConversation from "./BriefConversation";
import Sidebar8 from "./sidebar8";
import { Helmet } from "react-helmet";

export class MondayWorkManagement extends Component {
  render() {
    const formtext = (
      <>
        <div className="formContentBox">
          <h1 className="hTitle1 formullimb">
            Submit this form for free consultations:
          </h1>

          <p>
            Drop us a message, and we'll get in touch to discuss your
            requirements and explore how we can assist you.
          </p>
        </div>
      </>
    );

    return (
      <>
      <Helmet>
            <title>Monday Work Management - Thinqloud</title>
      </Helmet>
      <div className="site-main">
        <Header />
        <div className="ttm-page-title-row ttm-page-title-row16 ttmpagetitlerow5">
          <div className="container-xl">
            <div className="row">
              <div className="col-md-12">
                <div className="title-box text-center">
                  <div className="page-title-heading">
                    <h2 className="title sh2">Monday Work Management</h2>
                    <h1 className="title sh2 displyNone">Monday Work Management</h1>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <a title="Homepage" href={process.env.PUBLIC_URL + "/"}>
                        <i className="ti ti-home" />
                        &nbsp;&nbsp;Home
                      </a>
                    </span>
                    <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                    <span>Monday Work Management</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="ttm-service-description">
                    <p>
                      Work Management is a powerful, cloud-based platform
                      designed to streamline team collaboration, project
                      tracking, and workflow automation. It offers an intuitive,
                      highly visual interface that allows teams to plan,
                      execute, and monitor tasks in real-time. With customizable
                      boards, automation tools, and integrations with popular
                      apps like Slack, Google Drive, and Microsoft Teams,
                      Monday.com enables businesses to centralize work processes
                      and improve efficiency. Its flexibility makes it suitable
                      for teams of any size across various industries, from
                      marketing and software development to HR and operations.
                    </p>
                    <p>
                      This service empowers users to manage everything from
                      daily tasks to complex projects through features such as
                      timeline views, dashboards, time tracking, and file
                      sharing. With built-in templates and the ability to tailor
                      workflows to specific needs, Monday.com reduces manual
                      work and increases transparency across teams. Whether
                      you're tracking progress, assigning responsibilities, or
                      analyzing performance, Monday.com Work Management provides
                      the tools to enhance productivity and drive results.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <Sidebar8 />
              </div>
            </div>
          </div>
        </div>
        <BriefConversation formtext={formtext} />
      </div>
      </>
    );
  }
}

export default MondayWorkManagement;
